import { FunctionComponent } from 'react'

import { MdCheck } from 'react-icons/md'
import { Grid } from '@material-ui/core'

import Scaffold from 'shared/components/Scaffold'
import { colors } from 'shared/styles/colors'

import { IConfirmaTransferenciaProps } from './ConfirmaTransferenciaCompoenent'

const ConfirmaTransferencia: FunctionComponent<IConfirmaTransferenciaProps> = ({
  handleBackButton,
  handleNextButton,
  children,
}) => {
  return (
    <Scaffold
      onClickBackButton={handleBackButton}
      onClickNextButton={handleNextButton}
      titleBackButton="Voltar"
      titleNextButton="Confirmar"
      isNextButtonDisabled={false}
      showFooterScaffold
      icon={MdCheck}
      color={colors.green}
      title="Confirme os dados:"
    >
      <Grid container spacing={3}>
        {children}
      </Grid>
    </Scaffold>
  )
}

export default ConfirmaTransferencia
